import { muiPalette } from './muiPalette';

const thumbColor = '#fff';
const checkedColor = muiPalette.palette.primary.main;
const unCheckedColor = muiPalette.palette.grey[500];

export const switchOverride = {
  MuiSwitch: {
    styleOverrides: {
      root: {
        width: 56,
        height: 40,
        margin: '8px 0px'
      },
      track: {
        opacity: 1,
        borderRadius: 10,
        backgroundColor: unCheckedColor
      },
      switchBase: {
        top: 4,
        left: 4,
        padding: 10,
        borderRadius: 4,
        '&:hover': {
          backgroundColor: 'transparent'
        },
        '&.Mui-checked': {
          transform: 'translateX(16px)',
          '&:hover': {
            backgroundColor: 'transparent'
          },
          '& + .MuiSwitch-track': {
            opacity: 1
          }
        },
        '&.Mui-disabled': {
          '& + .MuiSwitch-track': {
            cursor: 'not-allowed',
            opacity: '0.4',
            backgroundColor: unCheckedColor
          },
          '&.Mui-checked + .MuiSwitch-track': {
            backgroundColor: checkedColor,
            cursor: 'not-allowed',
            opacity: '0.4'
          }
        },
        '&.Mui-focusVisible': {
          border: 'none',
          backgroundColor: muiPalette.palette.action.focus,
          '&.Mui-checked': {
            backgroundColor: muiPalette.palette.action.focus
          }
        }
      },
      thumb: {
        width: 12,
        height: 12,
        color: thumbColor
      },
      sizeSmall: {
        width: 32,
        height: 16,
        padding: 0,
        margin: 8,

        '& .MuiSwitch-thumb': {
          width: 12,
          height: 12
        },
        '& .MuiSwitch-switchBase': {
          padding: 2
        }
      }
    }
  }
};
